"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryReactorFormulas = void 0;

var _service = require("./../service");

var _CrudBuilder = require("./../service/CrudBuilder");

const BasisTheoryReactorFormulas = new _CrudBuilder.CrudBuilder(class BasisTheoryReactorFormulas extends _service.BasisTheoryService {}).create().retrieve().update().delete().list().build();
exports.BasisTheoryReactorFormulas = BasisTheoryReactorFormulas;